<script>
export default {
  name: "WorkspaceJsonSkillcourtRotterdamLayout",
  props: ["zones"]
};
</script>
<template>
  <div class="layout-container" v-if="zones">
    <div
      v-if="zones[5]"
      class="zone-6"
      :class="{
        greenBackground: zones[5].is_occupied,
        yellowBackground: zones[5].is_maintenance
      }"
    >
      <img
        class="zone-layout"
        src="../assets/LayoutRotterdam/20220207_zones-05.png"
        alt=""
      />
    </div>
    <div class="zone-group">
      <div class="zone-rest-outline" v-if="zones[6]">
        <img
          class="zone-layout"
          :class="{
            greenBackground: zones[6].is_occupied,
            yellowBackground: zones[6].is_maintenance
          }"
          src="../assets/LayoutRotterdam/20220207_zones-01.png"
          alt=""
        />
      </div>
      <div class="zone-rest-outline" v-if="zones[0] && zones[1] && zones[2]">
        <div class="zone-1-layout">
          <div
            :class="{
              greenBackground: zones[0].is_occupied,
              yellowBackground: zones[0].is_maintenance
            }"
          ></div>
          <div
            :class="{
              greenBackground: zones[1].is_occupied,
              yellowBackground: zones[1].is_maintenance
            }"
          ></div>
          <div
            :class="{
              greenBackground: zones[0].is_occupied,
              yellowBackground: zones[0].is_maintenance
            }"
          ></div>
          <div
            :class="{
              greenBackground: zones[2].is_occupied,
              yellowBackground: zones[2].is_maintenance
            }"
          ></div>
        </div>

        <img
          class="zone-layout"
          src="../assets/LayoutRotterdam/20220207_zones-02.png"
          alt=""
        />
      </div>
      <div
        class="zone-rest-outline"
        v-if="zones[3]"
        :class="{
          greenBackground: zones[3].is_occupied,
          yellowBackground: zones[3].is_maintenance
        }"
      >
        <img
          class="zone-layout"
          src="../assets/LayoutRotterdam/20220207_zones-03.png"
          alt=""
        />
      </div>
      <div
        class="zone-rest-outline"
        v-if="zones[4]"
        :class="{
          greenBackground: zones[4].is_occupied,
          yellowBackground: zones[4].is_maintenance
        }"
      >
        <img
          class="zone-layout"
          src="../assets/LayoutRotterdam/20220207_zones-04.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<style>
.layout-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.zone-6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 2px;
  border: solid 2px #767676;
}

.zone-layout {
  width: 100%;
  object-fit: contain;
  background: transparent;
  position: relative;
  z-index: 99;
}

.zone-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.zone-rest-outline {
  width: 140px;
  height: 140px;
  border-radius: 2px;
  border: solid 2px #767676;
  position: relative;
}

.zone-1-layout {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
}

.greenBackground {
  background-color: #1db75a;
}
.yellowBackground {
  background-color: #ffb818;
}
.transparentBackground {
  background-color: transparent;
}
</style>
